import { fromJS } from 'immutable';
import createAction from 'utils/redux-helpers/createAction';

const handler = (state, { data }) => state.set('inventory', fromJS(data));

export const setInventory = createAction({
  action: ['setInventory', 'data'],
  handler,
});
